import { showAlert } from "helper";
import { Box } from "@mui/material";
import styled from "styled-components";
import React, { useState } from "react";
import FormField from "components/FormField";
import { useSelector, useDispatch } from "react-redux";
import { createTeamApi } from "services/post/createTeam";
import TooltipIconButton from "components/TooltipIconButton";
import { fetchProfile } from "../../../../actions/profileActions"
import { AddCircleOutline, DeleteOutline, LockOutlined } from "@mui/icons-material";

const TeamsTab = styled.div`
  input {
    padding-right: 45px !important;
  }
`;

const TeamsList = styled.div`
  h2 {
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    margin-bottom: 13px;
  }

  .header-box {
    border-top: 1px solid #a0a0a0;
    border-bottom: 1px solid #a0a0a0;

    .team-name {
      width: 70%;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
    }

    .team-member-counts {
      width: 15%;
      text-align: center;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
    }

    .actions {
      width: 15%;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        font-size: 1.4rem !important;
      }
    }
  }

  .team-item {
    border-bottom: 1px solid #a0a0a0;
    .team-name {
      width: 70%;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
    }

    .team-member-counts {
      width: 15%;
      text-align: center;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
    }

    .actions {
      width: 15%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

const LockedHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 13px;

  h2 {
    margin: 0;
  }

  button {
    margin-left: 5px;
  }

  svg {
    font-size: 18px !important;
  }
`;

const TeamsContent = (props) => {
  const dispatch = useDispatch();
  const [team, setTeam] = useState("");
  const [isLocked, setIsLocked] = useState(false);
  const [selectedTeamIDs, setSelectedTeamIDs] = useState([]);
  const profile = useSelector(state => state.profile.profile);

  const handleChange = (e) => {
    setTeam(e.target.value);
  };

  const handleChangeTeam = (id) => {
    if (selectedTeamIDs.includes(id)) {
      setSelectedTeamIDs(selectedTeamIDs.filter((uid) => uid !== id));
    } else {
      setSelectedTeamIDs([...selectedTeamIDs, id]);
    }
  };

  const deleteTeams = () => {
    props.deleteTeamsFunction(selectedTeamIDs);
    setSelectedTeamIDs([]);
    fetchProfile(dispatch);
  };

  const addTeam = async () => {
    if (!profile.organizations) return
    
    const org_id = profile.organizations[0].id;
    const data = { name: team, organization: org_id };
    const response = await createTeamApi(data);
    if (response && response.status === 201) {
      const newData = {
        id: response?.data?.id,
        name: response?.data?.name,
        organization: response?.data?.organization,
        membersCount: 0,
      };
      props.addTeamFunction(newData);
      showAlert('success', 'Team has been successfully created!'); 
    }
  };

  return (
    <TeamsTab>
      <FormField label="Add Team" id="add-team">
        <input id="add-team" type="text" placeholder="Enter Team Name" value={team} onChange={handleChange} />
        <TooltipIconButton title="Add Team" ariaLabel="add-team" onClick={addTeam} placement="right" size={44} position="true" right={1} bottom={1}>
          <AddCircleOutline fontSize="large" />
        </TooltipIconButton>
      </FormField>
      <TeamsList>
        {isLocked ? 
        (<>
          <LockedHeader>
            <h2>Teams</h2>
            <TooltipIconButton title="Starter, Professional or Enterprise" ariaLabel="unlock-starter" placement="right" size={34} onClick={() => setIsLocked(false)}>
              <LockOutlined fontSize="medium" />
            </TooltipIconButton>
          </LockedHeader>
          <Box display="flex" alignItems="center" justifyContent="space-between" className="header-box" padding="7px">
            <div className="team-name">Team Name</div>
            <div className="team-member-counts">USERS</div>
            <div className="actions">
              {props.teams.length > 0 ? 
              (<TooltipIconButton title="Delete Team" ariaLabel="delete-team" placement="right" size={24}>
                <DeleteOutline fontSize="small" />
              </TooltipIconButton>) 
              : 
              null}
            </div>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="space-between" className="team-item disabled" padding="7px">
            <div className="team-name"></div>
            <div className="team-member-counts">0</div>
            <div className="actions custom-checkbox">
              <input type="checkbox" id="custom-checkbox" disabled />
              <label htmlFor="custom-checkbox" />
            </div>
          </Box>
        </>) 
        :
        (<>
          <h2>Teams</h2>
          <Box display="flex" alignItems="center" justifyContent="space-between" className="header-box" padding="7px">
            <div className="team-name">Team Name</div>
            <div className="team-member-counts">USERS</div>
            <div className="actions">
              {props.teams.length > 0 ? 
              (<TooltipIconButton title="Delete Team" ariaLabel="delete-team" placement="right" size={24} onClick={deleteTeams}>
                <DeleteOutline fontSize="small" />
              </TooltipIconButton>) 
              : 
              null}
            </div>
          </Box>
          {props.teams && props.teams.map((team, index) => (
            <Box display="flex" alignItems="center" justifyContent="space-between" className="team-item" padding="7px" key={index}>
              <div className="team-name">{team?.name}</div>
              <div className="team-member-counts">{team?.membersCount}</div>
              <div className="actions custom-checkbox">
                <input type="checkbox" id={`checkbox-` + index} checked={selectedTeamIDs.includes(team?.id)} onChange={() => handleChangeTeam(team?.id)} />
                <label htmlFor={`checkbox-` + index} />
              </div>
            </Box>
          ))}
        </>)}
      </TeamsList>
    </TeamsTab>
  );
};

export default TeamsContent;